import {
  FormGroup, Stack, Typography,
} from '@mui/material';
import { IOSSwitch } from './styles';

export default function CustomizedSwitch({ title, swithRegisterBankAccount, onSwithRegisterBankAccount }) {
  const handleChange = (event) => {
    onSwithRegisterBankAccount(event.target.checked);
  };

  return (
    <FormGroup>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography>{title}</Typography>
        <IOSSwitch
          sx={{ m: 1 }}
          checked={swithRegisterBankAccount}
          onChange={handleChange}
        />
      </Stack>
    </FormGroup>
  );
}
